import { ApplicationRef, Component, ComponentFactoryResolver, ElementRef, EventEmitter, Injector, Input, OnInit, Output, ViewChild, Renderer2, SimpleChanges } from '@angular/core';
import { SwMassageConfirmComponent } from 'src/app/librarys/components/basic-components/sw-massage-confirm/sw-massage-confirm.component';
import { SwPhotoAlbumService } from 'src/app/librarys/components/basic-components/sw-photo-album/sw-photo-album.service';
import { GetSuffixImgService } from 'src/app/librarys/serves/public/get-suffix-img.service';
import { GetUserModelService } from 'src/app/librarys/serves/public/get-user-model.service';
import { SwViewFileService } from 'src/app/librarys/serves/public/sw-view-file.service';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { environment } from 'src/environments/environment';
import { KmsFileUploaderBoxComponent } from './kms-file-uploader-box/kms-file-uploader-box.component';

@Component({
  selector: 'kms-file-uploader',
  templateUrl: './kms-file-uploader.component.html',
  styleUrls: ['./kms-file-uploader.component.css']
})
export class KmsFileUploaderComponent implements OnInit {

  /**
   * 上传前配置项的查询,根据父组件传递过来的值进行查询,functionId  或者是 code 任一种
   */
  @Input() fileFunctionId:string

  /**
   * 上传前配置项的查询,根据父组件传递过来的值进行查询,functionId  或者是 code 任一种
   */
  @Input() fileCode:string

  /**
   * 业务id
   */
  @Input() fileBusinessId:string  
 
  /**
   * 实体化 WebUploader时的id,如果一个页面上只需要一个文件上传组件,不需要传递此值
   */
  @Input() label3:string; 

  /**
   * 组件是否是只读属性
   */
  @Input() fileIsReadOnly:boolean = false 

  /**
   * 此上传组件是文件上传还是图片上传
   */
  @Input() fileOrImg :string = 'file' 

  /**
   * 不展示上传文件按钮以及文件展示,直接调用 selectFiles 方法,弹出模态框
   */
  @Input() justModal :boolean = false  

  /**
   * 没有业务id时,传入文件信息id进行回填
   */
  @Input() fileInfoIds :any[] = [] 
  
  /**
   * @ignore
   * 暂无附件时的提示内容
   */
  @Input() notip:string = "";

  /**
   * 输出属性,向父组件输出上传成功的文件信息
   */
  @Output() fileInfoToSubmit = new EventEmitter()
 
  /**
   * 输出属性,向父组件输出所有列表信息--showList1(页面上的文件列表)
   */
  @Output() updateSort = new EventEmitter()

  /**
   * 输出属性,将设置为封面图的文件抛出
   */
  @Output() fileSetAsCover = new EventEmitter()

  /**
   * @ignore
   * 上传成功的文件和删除的文件信息
   */
  list:any = {   
    'addList':[],
    'delList':[]
  }

  /**
   * @ignore
   * 确认弹窗组件
   */
  @ViewChild("tirm") tirm: SwMassageConfirmComponent;
 


  /**
   * @ignore
   * 展示在页面上的文件列表
   */
  showList1:any[] = [] 



  /**
   * @ignore
   * 存放根据策略得到的提示语
   */
  tip:any


  /**
   * @ignore
   * 文件处理微服务api
   */
  fileUrl :string = environment.fileWebAPI

  /**
   * @ignore
   * 根据策略查询配置是否成功,如果没有成功,就展示假上传按钮,默认成功
   */
  getOptionSuccess:boolean = true  

  /**
   * @ignore
   * 预览功能
   */
  swViewFileComponentRef:any;

  /**
  * 可以设置为封面图的文件类型
  * @ignore
  */
  imgSuffix:any[] = ['jpg','jpeg','png','bmp','gif'] 

  /**
   * @ignore
   * 文件策略配置中是否允许设置封面图,默认不能
   */
  isCover:boolean = false;

  /**
  * 可以在线编辑的文件类型
  * @ignore
  */
  editSuffix:any[] = ['doc','docx','xls','xlsx'] 

  /**
   * @ignore
   * 文件策略配置中是否允许在线编辑,默认不能
   */
  isEdit:boolean = false;

  //强制性有在线编辑按钮,如果流程关键字是 CKF_COLLECT ，就有在线编辑按钮
  @Input() flowKeyWord:string

  /**
   * @ignore
   * 配置文件中的是否出现同步至我的资产按钮
   */
  canSaveFileToUserResource:boolean = false;

  /**
   * @ignore
   * 当前登录用户信息
   */
  user:any


  /**
   * @ignore
   * 创建上传对象需要的参数
   */
  options5 = {
      server:environment.fileWebAPI + "file/fileUpload", //文件接收服务器
      auto: false,   //选完文件后是否自动上传
      resize: false,  //
      dnd: '#uploader',   //指定 Drag And Drop 拖拽的容器,如果不知道,择不启动
      paste: '#uploader',  //指定监听paste事件的容器,如果不指定则不起都过此功能.此功能为通过粘贴来添加截屏的图片,建议设置为document.body
      pick: {
        id: '#filePicker',
        label: '选择文件',
        multiple: true,   //是否能够多个文件上传,数据从父组件传递过来
      },
      accept: {   //只允许上传图片文件
        title: '',
        extensions: 'gif,jpg,jpeg,bmp,png',
        // mimeTypes: 'image/*',
        //点击选择文件之后会有延迟,解决方法:
        mimeTypes: 'image/gif,image/jpg,image/jpeg,image/png,image/bmp'
      },
      fileNumLimit:100 , 
      compress:false,
      chunked:true,     //分片上传大文件
      chunkSize:1024*1024*1,
      chunkRetry:5,     // 如果某个分片由于网络出现问题错误,允许自动上传多少次
      threads:3,        //最大上传并发数
      method:'Post',
      fileSizeLimit:undefined,  //验证文件总大小是否超出限制,超出则不允许加入队列
      fileSingleSizeLimit:undefined,  //验证单个文件大小是否超出限制,超出则不允许加入队列
      duplicate:true,   //允许重复上传文件
    
  }

  /**
   * @ignore
   * 根据策略查到的上传配置对象
   */
  uploadObj:any

  /**
   * @ignore
   */
 constructor( 
   private el:ElementRef, 
   private http:SwHttpClientService, 
   private Jwt:SwJwtService,
   private renderer2:Renderer2, 
   private box:SwMassageBoxService,
   private systemId: SystemIdService,
   private applicationRef: ApplicationRef,
   private componentFactoryResolver: ComponentFactoryResolver,
   private injector: Injector,
   private view :SwViewFileService,  //文件预览服务
   private create:SwCreateModalComponentService,
   public popup: SwPhotoAlbumService , 
   private getUserModelService: GetUserModelService,
   private getSuffixImgService:GetSuffixImgService
   ) { }

  /**
  * @ignore
  * @param changes 
  */
 ngOnChanges(changes: SimpleChanges): void {
   if(changes.fileFunctionId || changes.fileCode || changes.fileBusinessId || changes.label3 || changes.fileIsReadOnly || changes.fileOrImg || changes.fileInfoIds){
    this.showList1 = []  //页面上的文件列表清空
    this.list = {
      'addList':[],
      'delList':[]
    }
    this.label3 = this.label3 || 'filePicker';
    this.options5.pick.id = this.label3 ? '#'+this.label3 : '#filePicker';
    //传入策略和业务id,查询uuids,查询到要展示的数据
    //业务不为空,就通过业务id和策略获取文件
    if(this.fileBusinessId && this.fileCode){
      this.getShowList1(this.fileBusinessId,this.fileCode)
    }
    if(this.fileBusinessId && this.fileFunctionId){
      this.getShowList1(this.fileBusinessId,this.fileFunctionId)
    }
    
    //业务为空,就通过文件id获取
    if(!this.fileBusinessId && this.fileInfoIds.length != 0){
      this.getShowList2(this.fileInfoIds)
    }
    
    //查看状态,且在页面上展示,且设置不需要查询策略的时候不查询策略
    if(this.fileIsReadOnly && !this.justModal){
      
    } else{  //其他状况下都要查询策略
      //当一个父组件中不止有一种上传组件时,点击选择文件没有创建上传对象成功,这里需要点击之后进行创建
      if(this.fileFunctionId || this.fileCode){
        //根据functionId 查询上传前配置
        if(this.fileFunctionId){
          this.http.Get(this.fileUrl+'fileConfig/queryFileConfigOfUploadBeforeByFunctionId?functionId='+this.fileFunctionId)
            .subscribe(ret=>{
              if(ret && ret.code == 200){
                this.uploadObj = ret.data;
                this.isCover = this.uploadObj.isCover
                this.isEdit = this.uploadObj.isOnlineEditing
                this.tip = '(允许上传类型:'+ (this.uploadObj.suffix || '请在上传策略中配置允许上传类型') +'; '+'允许上传文件大小:'+ (this.uploadObj.config.allowSize? this.uploadObj.config.allowSize +'M; ' : '无限制; ') + (this.uploadObj.config.tip?this.uploadObj.config.tip:'') + ')'
              } else{
                //查询失败
                this.box.danger("策略查询失败")
                this.getOptionSuccess = false  //展示假按钮
              }
              
            })
        }
        //根据code 查询上传前配置
        if(this.fileCode){
          this.http.Get(this.fileUrl+'fileConfig/queryFileConfigOfUploadBeforeByCode?code='+this.fileCode)
            .subscribe(ret=>{
              if(ret && ret.code == 200){
                this.uploadObj = ret.data;
                this.isCover = this.uploadObj.isCover
                this.isEdit = this.uploadObj.isOnlineEditing
                this.tip = '(允许上传类型:'+ (this.uploadObj.suffix || '请在上传策略中配置允许上传类型') +'; '+'允许上传文件大小:'+ (this.uploadObj.config.allowSize? this.uploadObj.config.allowSize +'M; ' : '无限制; ') + (this.uploadObj.config.tip?this.uploadObj.config.tip:'') + ')'
              } else{
                //查询失败
                this.box.danger("策略查询失败")
                this.getOptionSuccess = false  //展示假按钮
              }
            })
        }
      }
    }
   }
 }

 /**
  * @ignore
  */
 ngOnInit() {
  //能否出现'同步至我的资产'按钮，有两个条件
  // 1.前台配置文件参数判断 -- this.canSaveFileToUserResource
   this.canSaveFileToUserResource = environment.syncToUserResource
  // 2.文件的创建人是否与当前用户一致，一致才能出现该按钮， 此时先获取登录用户信息
  this.user = this.getUserModelService.getUser()
  
 }

 /**
  * @ignore
  */
 ngAfterViewInit(): void {
  // if(!this.fileIsReadOnly){
    if(!this.fileFunctionId && !this.fileCode){
      this.tip = '(没有上传策略,默认允许上传类型：gif，jpg，jpeg，bmp，png)'
      this.getOptionSuccess = true  //正常展示
    }
  // }
 }

 /**
  * 根据业务id和策略标识进行回显(从附件表中查)
  * @ignore
  * @param fileBusinessId 
  * @param fileCode 
  */
  getShowList1(fileBusinessId,fileCode){
    this.http.Post(environment.fileWebAPI+'refFileObject/queryPageList',{'objectId':fileBusinessId,'code':fileCode,'pageSize':0,'pageNum':0})
    .subscribe(res=>{
      if(res && res.code == 200){
        let resArr = res.data.records.filter(item=> !item.isDeleted)  //过滤掉伪删除的文件
        resArr.forEach(item => {
          this.getImgBySuffix(item)
          item.nameWithoutSuffix = item.fileOldname.slice(0,item.fileOldname.lastIndexOf('.'))
        });
        this.showList1 = JSON.parse(JSON.stringify(resArr))
        // this.showList2 = JSON.parse(arrStr)
        this.updateSort.emit(this.showList1)    //在不知道文件的id时进行回显,有地方需要知道附件表中是否有文件,所以新增此行代码
      } else{
        this.box.danger("网络错误,无法获取列表")
      }
    })
  }

  /**
  * 根据文件信息的fileIndoId进行回显(从文件系统中查),文件的sort默认都0,且不能修改,业务只有排序是修改的附件表中的文件属性
  * @ignore
  * @param ids
  */
  getShowList2(ids){
    let datas = {
      ids:ids
    }
    this.http.Post(this.fileUrl + "fileInfo/queryByIdList" , datas).subscribe(res=>{
      if(res && res.code == 200){
        let resArr = res.data.filter(item=> !item.isDeleted)  //过滤掉伪删除的文件
        resArr.forEach(item => {
          this.getImgBySuffix(item)
          item.sort = 0 
          item.nameWithoutSuffix = item.fileOldname.slice(0,item.fileOldname.lastIndexOf('.'))
        });
        this.showList1 = JSON.parse(JSON.stringify(resArr))
        this.updateSort.emit(this.showList1)    //在不知道文件的id时进行回显,有地方需要知道附件表中是否有文件,所以新增此行代码
      } else{
        this.box.danger("网络错误,无法获取列表")
      }
    })
  }

  /**
  * 根据文件后缀判断显示的图片,如果不是图片类型就使用默认图片
  * @ignore
  * @param file
  */
  getImgBySuffix(file){
    // file.fileSizeToKB = Math.ceil(file.fileSize /1024 *100) /100
    if(file.fileSuffix){
      let fileSuffix = file.fileSuffix.toLocaleLowerCase()
      if(fileSuffix){
        //根据后缀得到文件类型图片
        file.src = this.getSuffixImgService.getFileTypeImg(fileSuffix)  
        if(file.src == 'assets/Images/files/img.png'){
          let name:string = file.fileName;
          if(name){
            let index = name.lastIndexOf('.');
            name = name.substring(0,index)+'_300@x.' + file.fileSuffix
            file.src = environment.staticFileUrl+file.filePath + 'THUMB/'+name
          }
        }
        /* if(fileSuffix == 'jpg' || fileSuffix == 'jpeg' || fileSuffix == 'bmp' || fileSuffix == 'png' || fileSuffix == 'gif'){
          file.src = environment.staticFileUrl + file.filePath + file.fileName
        } else if(fileSuffix == 'docx' || fileSuffix == 'doc'){
          file.src = 'assets/Images/files/doc.png'
        }else if(fileSuffix == 'xls' || fileSuffix == 'xlsx'){
          file.src = 'assets/Images/files/xls.png'
        }else if(fileSuffix == 'pdf'){
          file.src = 'assets/Images/files/pdf.png'
        }else if(fileSuffix == 'mp3' || fileSuffix == 'wma' || fileSuffix == 'rm' || fileSuffix == 'rmvb' || fileSuffix == 'mpg' || fileSuffix == 'mov' || fileSuffix == 'mkv' || fileSuffix == 'wav' || fileSuffix == 'cda'){
          file.src = 'assets/Images/files/audio.png'
        }else if(fileSuffix == 'mp4' || fileSuffix == 'avi' || fileSuffix == 'flv' || fileSuffix == 'ogg' || fileSuffix == 'wmv' || fileSuffix == 'asf' || fileSuffix == 'mpg'){
          file.src = 'assets/Images/files/video.png'
        }else if(fileSuffix == 'txt'){
          file.src = 'assets/Images/files/txt.png'
        }else if(fileSuffix == 'zip'){
          file.src = 'assets/Images/files/zip.png'
        } else{
          file.src = 'assets/Images/files/txt.png'
        } */
      } 
    }
  }

  /**
  * 根据sort将showList进行排序
  * @ignore
  * @param arr
  */
  sortUpdate(arr){
    return arr.sort(function(a,b){
      return a.sort - b.sort
    })
  }

  

  /**
  * 可以选择调用此仿佛弹出上传文件组件的模态框
  */
  selectFiles(){
    //创建dom节点
    const com = document.createElement(KmsFileUploaderBoxComponent.name);
    //创建动态组件
    const factory = this.componentFactoryResolver.resolveComponentFactory(KmsFileUploaderBoxComponent);
    const kmsFileUploaderBoxComponentRef = factory.create(this.injector, [], com);
    this.applicationRef.attachView(kmsFileUploaderBoxComponentRef.hostView);

    //组件的关闭事件
    kmsFileUploaderBoxComponentRef.instance["callback"].subscribe(data => {
      if (data){  //点击确定关闭模态框
        this.list = JSON.parse(JSON.stringify(data.list));
        //如果有修改文件信息,就对页面上的文件列表进行更新
        let fileArr = []
        data.showList2.forEach(file => {
          fileArr.push(file)
        });
        this.showList1 = fileArr
        
        this.fileInfoToSubmit.emit(data.list)  //将变动信息传递出去,让父组件从附件表中删除文件信息
        this.updateSort.emit(data.showList2)  //将页面上所有的文件信息传递出去
      } 

      document.body.removeChild(com);
      this.applicationRef.detachView(kmsFileUploaderBoxComponentRef.hostView);
      kmsFileUploaderBoxComponentRef.destroy()

    });
    //传递参数
    kmsFileUploaderBoxComponentRef.instance["fileFunctionId"] = this.fileFunctionId;
    kmsFileUploaderBoxComponentRef.instance["fileCode"] = this.fileCode;
    kmsFileUploaderBoxComponentRef.instance["fileBusinessId"] = this.fileBusinessId;
    kmsFileUploaderBoxComponentRef.instance["label3"] = this.label3;
    kmsFileUploaderBoxComponentRef.instance["fileInfoIds"] = this.fileInfoIds;
    kmsFileUploaderBoxComponentRef.instance["uploadObj"] = this.uploadObj;
    kmsFileUploaderBoxComponentRef.instance["justModal"] = this.justModal;
    kmsFileUploaderBoxComponentRef.instance["fileIsReadOnly"] = this.fileIsReadOnly;
    kmsFileUploaderBoxComponentRef.instance["showList2"] = JSON.parse(JSON.stringify(this.showList1));
    kmsFileUploaderBoxComponentRef.instance["getOptionSuccess"] = this.getOptionSuccess;
    kmsFileUploaderBoxComponentRef.instance["list"] = JSON.parse(JSON.stringify(this.list));

    document.body.appendChild(com);
  }

 

  /**
  * 点击页面上的删除按钮,如果该文件是回显的文件就加到delList中去,如果是刚刚新上传的文件就将之从addList中删除, 并将之从showList1 中删除
  * @ignore
  * @param item
  */
  deteleFile(item){
    //创建dom节点
    const com = document.createElement(SwMassageConfirmComponent.name);
    //创建动态组件
    const factory = this.componentFactoryResolver.resolveComponentFactory(SwMassageConfirmComponent);
    const swMassageConfirmComponentRef = factory.create(this.injector, [], com);
    this.applicationRef.attachView(swMassageConfirmComponentRef.hostView);
   
    //组件的关闭事件getFormLink
    swMassageConfirmComponentRef.instance["voted"].subscribe(data => {
      if (data){
        //从文件系统中删除文件
        let data = {
          'ids':[String([item.fileInfoId])]
        }
        this.http.Post(this.fileUrl + 'fileInfo/deleteBatch',data)
        .subscribe(res=>{
          //删除后重新获取所有已经上传的所有的文件信息,将数组更新,重新渲染页面 
          if(res.code == 200){
            //新删除的文件要从addList中删除
            this.list.addList = this.list.addList.filter(ele=>ele.fileInfoId !== item.fileInfoId)
            if(item.fileObjectId){
              //如果是附件表中已存在的,就加到delList里面
              this.list.delList.push(item.fileInfoId)
            }
            //如果 fileBusinessId 业务id不存在, fileInfoIds 存在,且删除的文件id在 fileInfoIds 中存在,也要加到 delList里面去
            if(!this.fileBusinessId && this.fileInfoIds.length && this.fileInfoIds.indexOf(item.fileInfoId) != -1){
              this.list.delList.push(item.fileInfoId)
            }
            //将该文件信息从页面删除
            this.showList1 = this.showList1.filter(ele=>ele.fileInfoId !== item.fileInfoId)
            this.fileInfoToSubmit.emit(this.list)  //将变动信息传递出去,让父组件从附件表中删除文件信息
            this.updateSort.emit(this.showList1)
          } else{
            this.box.danger("删除失败")
          }
        })
      }
      document.body.removeChild(com);
      this.applicationRef.detachView(swMassageConfirmComponentRef.hostView);
      swMassageConfirmComponentRef.destroy()

    });

    swMassageConfirmComponentRef.instance["Title"] = "该文件将从文件系统中删除，吗？";
    swMassageConfirmComponentRef.instance["createType"] = 2;
    document.body.appendChild(com);
    
  }

  /**
  * 点击已经上传的文件的下载按钮,将文件下载到本地
  * @ignore
  * @param file
  */
  downloadFile(file){
    let fileId = file.fileInfoId
    //不可行，360跳转了，有下载弹窗
    // window.location.href = this.fileUrl + "fileDownload/download?fileId="+fileId;

    //可行，360没有跳转
    var elemIF = document.createElement("iframe");
    elemIF.src = this.fileUrl + "fileDownload/download?fileId="+fileId;
    elemIF.style.display = "none"; 
    document.body.appendChild(elemIF);
    setTimeout(() => {
      document.body.removeChild(elemIF)
    }, 3000);

    /* 
    //不可行，360跳转了，有下载弹窗
    var a = document.createElement("a");
     a.download = file.fileOldname;
     a.href = this.fileUrl + "fileDownload/download?fileId="+fileId;
     $("body").append(a); // 修复firefox中无法触发click
     a.click();
     $(a).remove(); */
    
     /* //不可行，360跳转了，没有下载弹窗
    var form=$("<form>");
    form.attr("style","display:none");
    form.attr("target","");
    form.attr("method","get"); 
    form.attr("action",this.fileUrl + "fileDownload/download?fileId="+fileId);
    $("body").append(form);
    form.submit(); */
  }
 
  /**
  * 预览功能
  * @ignore
  */
  viewFile(file){
    //如果预览的是图片,就要把页面上的所有图片都过滤出来,一起预览
    //调用文件预览服务
    this.view.viewFile(environment.staticFileUrl+file.filePath+file.fileName,file.serverPath+file.filePath+file.fileName,file,this.showList1)
    
  }
 
  /**
  * 判断是否出现 设置为封面图按钮
  * @ignore
  */
  ableCover(file){ 
    return this.imgSuffix.indexOf(file.fileSuffix.toLocaleLowerCase()) != -1 && this.isCover
  }

  /**
  * 点击 设置为封面图 按钮
  * @ignore
  */
  setAsCover(file){
    let a = this.imgSuffix.indexOf(file.fileSuffix.toLocaleLowerCase())
    if(a != -1){
      //如果是图片类型,就抛出
      this.fileSetAsCover.emit(file)
    } else {
      this.box.danger("该类型文件不能够设置为封面图")
    }
  }  

  /**
  * 判断是否出现 在线编辑按钮
  * @ignore
  */
  ableEdit(file){ 
    return this.editSuffix.indexOf(file.fileSuffix.toLocaleLowerCase()) != -1 && this.isEdit
  }

  ableEdit1(file){ 
    return this.editSuffix.indexOf(file.fileSuffix.toLocaleLowerCase()) != -1 
  }

  /**
  * 点击 在线编辑按钮
  * @ignore
  */
  editFile(file){
    if(file.fileSuffix == 'doc' || file.fileSuffix == 'docx'){
      //如果是word文档
      window.open(environment.onlineOfficeWebAPI + "word?url=" + file.filePath + file.fileName)
      // this.http.Get(environment.onlineofficeWebApi + "word?url=" + file.filePath + file.fileName).subscribe(res=>{
      // })
    } else if(file.fileSuffix == 'xls' || file.fileSuffix == 'xlsx'){
      //如果是excel表格
      window.open(environment.onlineOfficeWebAPI + "excel?url=" + file.filePath + file.fileName)
      // this.http.Get(environment.onlineofficeWebApi + "excel?url=" + file.filePath + file.fileName).subscribe(res=>{
      // })
    } else {
      this.box.danger("该类型文件不支持在线编辑")
    }
  }

  /**
  * 点击同步至我的资产按钮
  * @ignore
  */
  saveToUserResource(file){
    this.http.Post(environment.seekerWebAPI + 'applicationConfig/queryApplicationConfigSonsByConfigKey', {str:'FILE_RES_SYNC'}).subscribe(r=>{
      if(r && r.code == 200){
        if(r['data'][0]['configValue']){
          //获取同步微服务
          let syncAPI = r['data'][0]['configValue']
          let param = {fileId : file.fileInfoId}
          // 访问我的资产接口/resource/queryList，参数{fileId：文件ID}，看是否能查出数据，如果不能查出来就可以同步到我的资产
          this.http.Post(syncAPI + "resource/queryList" , param).subscribe(res=>{
            if(res && res.code == 200){
              if(res.data.records.length == 0){
                //如果没查询到结果，就可以同步至我的资产
                this.http.Post(syncAPI + "resource/saveByFileInfo" , file).subscribe(r=>{
                  if(r && r.code == 200){
                    this.box.success('操作成功')
                  }
                })
              } else {
                //如果能够查到结果，就提示文件已存在
                this.box.danger('文件已存在')
              }
            } else {
              this.box.danger(res.msg)
            }
          })
        }
      }
        
    })
  }

}
